import { Permissions, UserRole } from './constants';

// From src/constants/resources.ts, e.g Roles, WidgetConfigs
export type Resource = string;

export interface Permission {
  [resource: string]: Permissions[];
}

export enum UserTypes {
  UPSTART = 'Upstart',
  DEALER = 'Dealer',
}

export interface Role {
  role: UserRole;
  permissions: Permission;
  accessibleRoles?: UserRole[];
  publicName?: string;
  allowedUserTypes?: UserTypes[];
  publicDescription?: string;
  internalDescription?: string;
}

// only these roles can desk deals
export const allowedDeskDealRoles = [
  UserRole.DESKING_MANAGER,
  UserRole.ADMIN,
  UserRole.DEALER_ADMIN,
  UserRole.DIGITAL_FINANCE_FINANCE_MANAGER,
  UserRole.DIGITAL_FINANCE_SALES_MANAGER,
] as string[];
